import React from "react";

function ActiveInvestmentDetailsTab({ mockData }) {
  if (!mockData) return null;

  const investmentDetails = [
    {
      label: "Annual dividend",
      value: mockData.annualDividend,
    },
    {
      label: "Last dividend paid",
      value: mockData.lastDividendPaid,
    },
    {
      label: "Next dividend",
      value: mockData.nextDividend,
    },
    {
      label: "Holding since",
      value: mockData.holdingSince,
    },
    {
      label: "Liquidation eligibility",
      value: mockData.liquidationEligibility,
    },
  ];

  const monthsRemaining = mockData.monthsRemaining;

  const eligibilityText =
    monthsRemaining === null
      ? "Eligibility date unavailable"
      : monthsRemaining === 0
        ? "Eligible now"
        : `${monthsRemaining} month${monthsRemaining === 1 ? "" : "s"} remaining`;

  return (
    <div className="border border-gray-100 rounded-xl p-5 shadow-sm bg-white">
      <h3 className="text-back-color2 font-bold text-[14px] mb-4">
        Co-ownership Position
      </h3>

      {/* Investment Details */}
      {investmentDetails.map(({ label, value }, index) => (
        <div
          key={label}
          className={`flex justify-between gap-4 py-3 ${
            index !== investmentDetails.length - 1
              ? "border-b border-gray-50"
              : ""
          }`}
        >
          <p className="text-[#14013A] font-[500] text-[13px]">{label}</p>

          <p className="text-[#14013A] text-[12px] font-[600] text-right">
            {value ?? "N/A"}
          </p>
        </div>
      ))}

      {/* Months Remaining */}
      <div className="text-center mt-3 pt-2">
        <p className="text-[#808285] text-[12px]">{eligibilityText}</p>
      </div>
    </div>
  );
}

export default ActiveInvestmentDetailsTab;
